import { BodyText, LabelText } from '@ui-components/typography/Typography'
import { JSX } from 'react'
import { useIntl } from 'react-intl'

import { getFullname } from '../utils'

export const NameBase = (
  props: {
    firstNames?: string
    lastName?: string
    label?: string
    kind: 'plain' | 'labelled'
  } & React.PropsWithChildren,
): JSX.Element => {
  const intl = useIntl()
  const { lastName, firstNames, label, children, kind } = props
  const labelToUse = label ?? intl.formatMessage({ id: 'common-cards-contact-info-name-label' })
  const name = getFullname({ firstNames, lastName })

  return (
    <div data-testid="name-and-children-section">
      {kind === 'labelled' && <LabelText tagName="div">{labelToUse}</LabelText>}
      <BodyText tagName="p" data-testid="name-and-address">
        {name}
        {children && (
          <>
            <br />
            {children}
          </>
        )}
      </BodyText>
    </div>
  )
}
